import { type ReactNode } from 'react';

import { Badge } from '@/ui/primitives/badge';
import { type TomBadge } from '@/ui/primitives/estilos';

interface StatusProps {
  tom: TomBadge;
  children: string;
  /** Processo em andamento: o ponto pulsa. */
  ativo?: boolean;
  /** Ícone no lugar do ponto (situações com forma própria: relógio, cadeado). Decorativo. */
  icone?: ReactNode;
}

/** Estado de um processo (lote, pendência) — selo discreto com ponto. Situação fiscal usa Carimbo. */
export function Status({ tom, children, ativo = false, icone }: StatusProps) {
  return (
    <Badge tom={tom}>
      {icone ? (
        <span aria-hidden className="inline-flex">
          {icone}
        </span>
      ) : (
        <span
          aria-hidden
          className={`size-1.5 rounded-pilula bg-current ${ativo ? 'animate-pulso' : ''}`}
        />
      )}
      {children}
    </Badge>
  );
}
